import { NewVision, Vision } from '@griply/types';

import { DocumentSnapshot } from '../types/firestore';
import { firebaseObjectTimestampToDate } from './firebase-timestamp-to-date';

export const visionConverter = {
  fromFirestore: (snapshot: DocumentSnapshot): Vision => {
    const data = firebaseObjectTimestampToDate(snapshot.data()) as Record<
      string,
      unknown
    >;

    return {
      ...data,
      images: Array.isArray(data.images) ? data.images : [],
      description: typeof data.description === 'string' ? data.description : '',
      lifeAreaId: data.lifeAreaId ?? null,
      createdAt: data.createdAt ?? new Date(),
      frozenAt: data.frozenAt ?? null,
    } as Vision;
  },
  toFirestore: (vision: Vision) => vision,
};

export const newVisionConverter = (vision: NewVision) => ({
  ...vision,
  createdAt: new Date(),
  description: vision.description ?? '',
  images: vision.images ?? [],
  lifeAreaId: vision.lifeAreaId ?? null,
  frozenAt: null,
});
